var _rect, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageNotFoundIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 240,
    viewBox: "0 0 376 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83.0189,
    y: 1.33151,
    width: 147.337,
    height: 118.337,
    rx: 11.9836,
    fill: "white",
    stroke: "#28293D",
    strokeWidth: 2.66303
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.5727 21.97H229.687",
    stroke: "#28293D",
    strokeWidth: 2.66303
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.687 65.6903L134.371 70.3742L139.055 75.0581",
    stroke: "#28293D",
    strokeWidth: 3.1226,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.055 65.6903L134.371 70.3742L129.687 75.0581",
    stroke: "#28293D",
    strokeWidth: 3.1226,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.727 61L175.411 65.6839L180.095 70.3678",
    stroke: "#28293D",
    strokeWidth: 3.1226,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.095 61L175.411 65.6839L170.727 70.3678",
    stroke: "#28293D",
    strokeWidth: 3.1226,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97.2194,
    cy: 11.9836,
    r: 3.99454,
    fill: "#28293D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.535,
    cy: 11.9836,
    r: 3.99454,
    fill: "#28293D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.85,
    cy: 11.9836,
    r: 3.99454,
    fill: "#28293D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.068 87.8607L170.745 83.2789",
    stroke: "#28293D",
    strokeWidth: 3.1226,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.08 87.859L140.197 95.5851C140.691 98.9987 143.859 101.366 147.272 100.872V100.872C150.686 100.378 153.053 97.2107 152.559 93.7971L151.442 86.071",
    stroke: "#28293D",
    strokeWidth: 3.1226
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 179.306V159.461L45.4419 94.4615H72.9084V158.023H84.7003V179.306H72.9084V198H48.318V179.306H0ZM50.0436 121.497L25.8846 158.023H50.0436V121.497Z",
    fill: "#28293D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.18 186.074C105.18 169.584 108.344 156.594 114.671 147.103C121.094 137.612 131.4 132.866 145.589 132.866C159.778 132.866 170.036 137.612 176.363 147.103C182.786 156.594 185.998 169.584 185.998 186.074C185.998 202.755 182.786 215.841 176.363 225.332C170.036 234.823 159.778 239.569 145.589 239.569C131.4 239.569 121.094 234.823 114.671 225.332C108.344 215.841 105.18 202.755 105.18 186.074ZM161.839 186.074C161.839 176.391 160.784 168.961 158.675 163.784C156.566 158.511 152.204 155.875 145.589 155.875C138.974 155.875 134.612 158.511 132.503 163.784C130.394 168.961 129.339 176.391 129.339 186.074C129.339 192.593 129.723 198.009 130.49 202.323C131.257 206.542 132.79 209.993 135.091 212.677C137.488 215.266 140.987 216.56 145.589 216.56C150.191 216.56 153.642 215.266 155.943 212.677C158.34 209.993 159.921 206.542 160.688 202.323C161.455 198.009 161.839 192.593 161.839 186.074Z",
    fill: "#28293D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M202 193.306V173.461L247.442 108.461H274.908V172.023H286.7V193.306H274.908V212H250.318V193.306H202ZM252.044 135.497L227.885 172.023H252.044V135.497Z",
    fill: "#28293D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M368.687 72L371.35 74.663M371.35 74.663L374.013 77.3261M371.35 74.663L374.013 72M371.35 74.663L368.687 77.3261",
    stroke: "#28293D",
    strokeWidth: 2.66303,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M295.687 125L301.679 130.992M301.679 130.992L307.671 136.984M301.679 130.992L307.671 125M301.679 130.992L295.687 136.984",
    stroke: "#28293D",
    strokeWidth: 5.99181,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M315.687 70L318.35 72.663M318.35 72.663L321.013 75.3261M318.35 72.663L321.013 70M318.35 72.663L315.687 75.3261",
    stroke: "#28293D",
    strokeWidth: 2.66303,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M331.687 88L335.682 91.9945M335.682 91.9945L339.676 95.9891M335.682 91.9945L339.676 88M335.682 91.9945L331.687 95.9891",
    stroke: "#28293D",
    strokeWidth: 2.66303,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M283.687 90L287.682 93.9945M287.682 93.9945L291.676 97.9891M287.682 93.9945L291.676 90M287.682 93.9945L283.687 97.9891",
    stroke: "#28293D",
    strokeWidth: 2.66303,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFoundIllustration);
export default __webpack_public_path__ + "static/media/PageNotFoundIllustration.17081a4a5ff639dd0367e23e248913d3.svg";
export { ForwardRef as ReactComponent };